import { partial } from 'filesize';

// cspell:ignore jedec
const formatFilesize = partial({ base: 2, standard: 'jedec' });

export const filesize = (value: number): string => formatFilesize(value);
